import React, { useRef, useState } from "react";
import { Form } from "react-bootstrap";
import FLInput from "../libs/uikit/flinput";
import CaptchaInput from "../libs/captcha";
import { MetroSpinner } from "react-spinners-kit";
import Language from "../../services/Language.js";

const l = new Language();

const QuickSearch = (props) => {
  const { url } = props;
  const [validated, setValidated] = useState(false);
  const [value, setValue] = useState("");
  const [gcn, setGCN] = useState("");
  const captchaRef = useRef(null);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    if (form.checkValidity() === false) {
      return setValidated(true);
    }
    if (!captchaRef.current.validate()) {
      return;
    }
    let data = {
      a1: gcn.trim(),
      a2: value.trim(),
      a3: "GENERAL",
    };
    props.search(data);
    captchaRef.current.reset();
  };

  const guideImg = props.isnotfound
    ? "/img/sdk/notfound.svg"
    : "/img/sdk/search-icon-big.svg";

  const guideMsg = props.isnotfound
    ? l.g("certificate.not_found_message", "Certificate not found. Please try again with advanced search")
    : l.g("certificate.search_guide_message", "Please search for the certificate by entering it in the search bar to view the certificate");

  return (
    <div>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <div className="row mt-3">
          <div className="col-12">
            <FLInput
              label={l.g("certificate.quick_search_label", "Email/ Full name/ Phone/ ID/ Passport")}
              required={true}
              value={value}
              changeEvent={setValue}
            />
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-12">
            <FLInput
              label={l.g("certificate.certificate_no_label", "Certificate number")}
              value={gcn}
              changeEvent={setGCN}
              required={true}
            />
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-12">
            <CaptchaInput ref={captchaRef} />
          </div>
        </div>

        {/* Nút tìm kiếm và kính lúp xếp chồng, cùng độ rộng với textbox */}
        <div className="row mt-3 align-items-center">
          {!props.certificate && (
            <div className="col-12 search-guide">
              <img
                src={guideImg}
                alt=""
                style={{ width: 40, height: 40, objectFit: "contain", opacity: 0.75 }}
              />
              <p style={{ fontSize: 11, color: props.isnotfound ? "#dc3545" : "#999", margin: 0 }}>
                {guideMsg}
              </p>
            </div>
          )}
          <div className="col-12 mt-3">
            <button className="btn-search-kt" disabled={props.loading}>
              {props.loading ? (
                <MetroSpinner size={28} loading={props.loading} />
              ) : (
                <>
                  <span className="icon-search-kt">
                    <i className="fas fa-search"></i>
                  </span>
                  {l.g("certificate.search_button", "Search")}
                </>
              )}
            </button>
          </div>
        </div>
      </Form>
    </div>
  );
};
export default QuickSearch;
